import React from 'react';
import { Error404Box } from 'components/error-handle/errors';
import { Link } from 'react-router-dom';
import { PageDecorated } from 'pages/page';
import { useTranslation } from 'react-i18next';

export function Error404Page() {
  const { t } = useTranslation();
  return (
    <PageDecorated className="ct-error-page">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <Error404Box>
              <h1>{t('page_not_found')}</h1>
              <p>{t('video_not_found_message')}</p>
              <p>
                {t('return_to')} <Link to="/">{t('home')}</Link>
              </p>
              <span>{t('site_error_404')}</span>
            </Error404Box>
          </div>
        </div>
      </div>
    </PageDecorated>
  );
}
